import { message } from 'antd';
import { useModel } from '../../use';
import { network, generators, asserts } from '../../../utils';
import getUdc from '../../../service/udc';
import api from '../../../config/api';

const initialState = {
  principal: {}, // 用户上下文
  imUserRespVO: {}, // 获取用户的环信账号信息
  memberInfo: {}, // 会员信息
  basicConfig: {}, // 基础配置
  permission: {}, // 部分权限
  topMenuList: [], // 顶部菜单
  middleMenuList: [], // 中部菜单
  isSpecialUser: false, // 订单中心只能下载品质证明的特殊角色   角色名称为品质证明下载
  permCart: {}, // 购物车
  days: [], //有货提醒和备货提醒天数
  orderTypeList: [],
  isSignIn: false,
  agentList: [], // 在线客服页面用到的客服数据
  env: null,
  webImNum: 0, //环信消息数量
  memberIsWhite: false, // 是否是白名单
  signPopUp: false, // 签到弹窗是否要展示
};

const reducers = {
  resetState: () => ({ ...initialState }),
  updateState: (state, payload) => ({ ...state, ...payload }),
  updatePrincipal: (state, payload) => ({ ...state, principal: payload }),
  updateImInfo: (state, payload) => ({ ...state, imUserRespVO: payload }),
  updateMemberInfo: (state, payload) => ({ ...state, memberInfo: payload }),
  updateDays: (state, payload) => ({ ...state, days: payload }),
  updateBasicConfig: (state, payload) => ({ ...state, basicConfig: payload }),
  updatePermission: (state, payload) => ({ ...state, permission: payload }),
  updateOrderTypeList: (state, payload) => ({ ...state, orderTypeList: payload }),
  updateCustomerList: (state, payload) => ({ ...state, agentList: payload }),
  updateMemberIsWhite: (state, payload) => ({ ...state, memberIsWhite: payload }),
  updateSignPopUp: (state, payload) => ({ ...state, signPopUp: payload }),
};

const effects = {
  fetchPrincipal: async ({ dispatch }) => {
    // 本接口改为静默调用；因为框架进入就会调用，而不需要权限的页面并不需要理会本接口的401返回；401交由具体页面的权限接口去界定即可。
    // 本接口调用场景只有两处，一处是首次/F5进入某个页面；一处是登陆成功之后。
    const response = await network.get(api.core.principal, { silence: true });
    if (response.success) {
      const result = generators.generatorObject(response.data);
      if (result.success) {
        dispatch('updatePrincipal')(generators.generatorObject(result.data));
        return generators.generatorObject(result.data);
      } else {
        return {};
      }
    }
  },
  fetchImInfo: async ({ dispatch }) => {
    const response = await network.get(api.webIm.fetchImInfo);
    if (response.success) {
      localStorage.setItem(
        'imUserRespVO',
        JSON.stringify(generators.generatorObject(response.data.data)),
      );
      dispatch('updateImInfo')(generators.generatorObject(response.data.data));
    }
  },
  fetchMemberIsWhite: async ({ dispatch }) => {
    const response = await network.get(api.profile.memberisBlack);
    if (response.success) {
      const { signPopup, isWhite } = response.data.data;
      // isWhite true 白名单  false 黑名单
      dispatch('updateMemberIsWhite')(isWhite);
      dispatch('updateSignPopUp')(signPopup);
    }
  },
  queryBasicConfig: async ({ dispatch }) => {
    const response = await network.get(api.core.basic);
    if (response.success) {
      if (response.data.success) {
        dispatch('updateBasicConfig')(generators.generatorObject(response.data.data));
      } else {
        message.error(response.data.message);
      }
    }
  },
  queryPermission: async ({ dispatch }) => {
    const response = await network.get(api.core.permission);
    if (response.success) {
      if (response.data.success) {
        dispatch('updatePermission')(generators.generatorObject(response.data.data));
      } else {
        message.error(response.data.message);
      }
    }
  },
  queryMenus: async ({ dispatch }) => {
    const response = await network.get(api.core.menus);
    if (response.success) {
      if (response.data.success) {
        const menuList = generators.generatorArray(response.data.data);
        const updateObj = {
          topMenuList: [],
          middleMenuList: [],
          permCart: {},
          profile: {},
          isSpecialUser: false,
        };
        menuList.forEach((menuType) => {
          if (menuType.moduCode === 'headerMenu') {
            // 顶部菜单
            updateObj.topMenuList = generators
              .generatorArray(menuType.children)
              .map(({ moduCode, moduName, menuUrl, linkType }) => ({
                moduCode,
                moduName,
                menuUrl,
                linkType,
              }));
          }
          if (menuType.moduCode === 'middleMenu') {
            // 导航栏菜单
            let middleMenuList = generators.generatorArray(menuType.children);
            if (middleMenuList.findIndex((item) => item.moduCode === 'custSpecialSo') > -1) {
              updateObj.isSpecialUser = true;
            }
            updateObj.middleMenuList = generators.generatorArray(menuType.children);
          }
          if (menuType.moduCode === 'custSoCart') {
            const { moduName, menuUrl } = menuType;
            updateObj.permCart = { moduName, menuUrl };
          }
          if (menuType.moduCode === 'memberCenter') {
            const { moduName, moduCode, children } = menuType;
            updateObj.profile = { moduName, moduCode, children };
          }
        });
        dispatch('updateState')(updateObj);
      } else {
        message.error(response.data.message);
      }
    }
  },
  //查询有货时间
  fetchDays: async ({ dispatch }) => {
    const response = await getUdc('arDayDesc');
    if (response.success) {
      const dataSource = generators.generatorArray(response.data).map((item) => ({
        ...item,
        desc: `${item.name}天内有货`,
      }));
      dispatch('updateDays')(dataSource);
    }
  },
  //查询订单类型
  fetchOrderType: async ({ dispatch }) => {
    const res = await getUdc('scAttributeDesc');
    if (res.success) {
      const dataSource = generators.generatorArray(res.data);
      dispatch('updateOrderTypeList')(dataSource);
    }
  },
  fetchMemberInfo: async ({ dispatch }) => {
    const response = await network.get(api.profile.memberPointsInfo);
    if (response.success) {
      dispatch('updateMemberInfo')(generators.generatorObject(response.data.data));
    }
  },
  // 用户当前是否签到
  fetchSignStatus: async ({ dispatch }) => {
    const response = await network.get(api.core.checkTodaySign);
    if (response.success) {
      dispatch('updateState')({ isSignIn: response.data.data });
    }
  },
  // 获取在线沟通客服数据
  fetchCustomerList: async ({ dispatch }) => {
    const res = await network.get(api.webIm.getCustomer);
    if (res.success) {
      const result = generators.generatorObject(res.data);
      dispatch('updateState')({ agentList: generators.generatorArray(result.data) });
    }
  },
  fetchEnvironment: async ({ dispatch }) => {
    const res = await network({
      url: api.finance.introduction,
      method: 'get',
      params: { confCode: 'currentEnvironment' },
    });
    if (res.success) {
      const [config = {}] = generators.generatorArray(generators.generatorObject(res.data).rows);
      if (asserts.isExist(config)) {
        localStorage.setItem('env', config.confValue);
        dispatch('updateState')({ env: config.confValue });
      }
    }
  },
  fetchWebImNum: async ({ dispatch, state, payload }) => {
    const imUserRespVO = JSON.parse(localStorage.getItem('imUserRespVO'));
    if (asserts.isExist(imUserRespVO)) {
      const { imUsername = '' } = imUserRespVO;
      const res = await network({
        url: api.webIm.getUnReadCount,
        method: 'post',
        data: { to: imUsername },
      });
      if (res.success) {
        const result = generators.generatorObject(res.data);
        if (result.success) {
          const num = Number(result.data) > 0 ? Number(result.data) : 0;
          dispatch('updateState')({ webImNum: num });
        }
      }
    }
  },
  updateImMsgCnt: async ({ dispatch, state, payload }) => {
    const { type } = payload;
    let webImNum = state.webImNum;
    if (type === 'plus') {
      webImNum = webImNum + 1;
    } else if (type === 'minus') {
      webImNum = Math.max(webImNum - 1, 0);
    } else if (type === 'init') {
      webImNum = 0;
    }
    dispatch('updateState')({ webImNum });
  },
};

const useContext = () => {
  const { state, dispatch } = useModel({
    state: initialState,
    reducers,
    effects,
  });

  return {
    ...state,
    updatePrincipal: dispatch('fetchPrincipal'),
    updateImInfo: dispatch('fetchImInfo'),
    updateMemberInfo: dispatch('fetchMemberInfo'),
    updateCartCount: () => {},
    updateBasicConfig: dispatch('queryBasicConfig'),
    updatePermission: dispatch('queryPermission'),
    updateDays: dispatch('fetchDays'),
    updateOrderType: dispatch('fetchOrderType'),
    updateSignStatus: dispatch('fetchSignStatus'),
    updateEnvironment: dispatch('fetchEnvironment'),
    updatehWebImNum: dispatch('fetchWebImNum'),
    updateImMsgCnt: dispatch('updateImMsgCnt'),
    updateMenus: dispatch('queryMenus'),
    updateCustomerList: dispatch('fetchCustomerList'),
    updateMemberisWhite: dispatch('fetchMemberIsWhite'),
    resetCtxState: dispatch('resetState'),
  };
};

export default useContext;
